import React, { useEffect, useRef, useState } from "react";
import "./jobScheduling.api";
import { ButtonGroup, Grid, Icon, Button } from "semantic-ui-react";
import MetaData from "../../components/MetaData";
import "react-loading-skeleton/dist/skeleton.css";
import "react-datepicker/dist/react-datepicker.css";
import "./jobScheduling.css";
import WeeklyView from "./WeeklyView";
import { apiGetTechnicianList } from "./jobScheduling.api";
import DailyView from "./DailyView";
import AgendaView from "./AgendaView";

import * as jobSchedulingReducer from "./jobScheduling.reducer";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const JobScheduling = (props) => {
  const [technicianList, setTechnicianList] = useState([]);
  const [view, setView] = useState("day");

  useEffect(() => {
    if (localStorage.getItem("isBoahubPremium") !== "true") {
      props.history.push("/");
    }

    props.actionSetSelectedDay(new Date());

    const delayDebounceFn = setTimeout(() => {
      getTechnicianList();
      getJobSchedulingList();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, []);

  const getJobSchedulingList = async () => {
    await props.actionGetJobSchedulingList("", null);
  };

  const getTechnicianList = async () => {
    const result = await apiGetTechnicianList();
    if (result) {
      const filterList = result.filter(
        (item, index) => result.indexOf(item) === index
      );
      setTechnicianList(filterList);
    }
  };

  return (
    <React.Fragment>
      <MetaData title="Job Management" />
      <Grid
        columns={3}
        divided
        className="job-management"
        style={{ marginTop: -30 }}
      >
        <Grid.Row style={{ paddingTop: 0, zIndex: 1 }}>
          <Grid.Column width={16} style={{ paddingRight: 0 }}>
            <h3 style={{ marginLeft: 20 }}>
              <Icon name="calendar alternate" /> Job Scheduling
            </h3>
            <Button
              size="tiny"
              className="edit-status"
              style={{ position: "absolute", top: 5, right: 25 }}
              onClick={() => props.history.push("/jobbing")}
            >
              <Icon name="configure" />
              Back to Jobbing
            </Button>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ paddingTop: 0 }}>
          <Grid.Column
            width={16}
            style={{ paddingRight: 0, overflow: "visible", paddingRight: 23 }}
          >
            <Grid>
              <Grid.Column width={16}>
                <div
                  style={{
                    position: "absolute",
                    top: 20,
                    right: 23,
                    zIndex: 98,
                  }}
                >
                  <ButtonGroup size="tiny">
                    <Button
                      onClick={() => setView("day")}
                      className={
                        view === "day" ? "active-status" : "inactive-status"
                      }
                      style={{
                        border: "1px solid #66cc23",
                      }}
                    >
                      Day
                    </Button>
                    <Button
                      onClick={() => setView("week")}
                      className={
                        view === "week" ? "active-status" : "inactive-status"
                      }
                      style={{
                        border: "1px solid #66cc23",
                        borderLeft: "none",
                      }}
                    >
                      Week
                    </Button>
                    <Button
                      onClick={() => setView("agenda")}
                      className={
                        view === "agenda" ? "active-status" : "inactive-status"
                      }
                      style={{
                        border: "1px solid #66cc23",
                        borderLeft: "none",
                      }}
                    >
                      Agenda
                    </Button>
                  </ButtonGroup>
                </div>
                <div>
                  {view === "week" ? (
                    <WeeklyView resources={technicianList} setView={setView} />
                  ) : view === "day" ? (
                    <DailyView resources={technicianList} />
                  ) : (
                    <AgendaView resources={technicianList} />
                  )}
                </div>
              </Grid.Column>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    scheduledJobs: state.jobScheduling.scheduledJobs,
    unscheduledJobs: state.jobScheduling.unscheduledJobs,
  };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(jobSchedulingReducer, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(JobScheduling)
);
